export default __webpack_public_path__ + "./images/as.6eefecf8.png";